import React, { Suspense, useState } from "react";
import { useNavigate } from "react-router-dom";
import { School, GraduationCap, Users } from "lucide-react";
import "../../App.css";
import "../landingpage.css";
import "./userlandingpage.css";
import userStore from "../../zustand/userStore";
import Footer from "../../components/Footer";
import UserHeader from "../../components/UserHeader";

const SOLUTION_ROUTES = {
  schools: { withPlan: "/dashboard", withoutPlan: "/dashboard" },
  tutors: { withPlan: "/tutor", withoutPlan: "/tutor/pricing" },
  coaching: { withPlan: "/coaching", withoutPlan: "/coaching/pricing" },
};

const UserLandingPage = () => {
  const navigate = useNavigate();
  const { userData } = userStore((state) => ({
    userData: state.user,
  }));

  const [highlightedCard] = useState(null);

  const handleSolutionNavigation = (solution) => {
    if (solution === "schools") {
      navigate("/guest-home");
      return;
    }
    if (solution === "tutors") {
      navigate("/tutor");
      return;
    }
    if (solution === "coaching") {
      navigate("/coaching");
      return;
    }
    navigate("/guest-home");
  };

  const handleProfileNavigation = () => {
    navigate("/profile");
  };

  const institutionName = userData?.school_name?.trim() || "";
  const accountHolderName = userData?.admin_name?.trim() || "";

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="landing-page">
        <div className="navbar-fixed-container">
          <UserHeader />
        </div>

        {/* --- HERO SECTION --- */}
        <div className="user-hero-section">
          <div className="user-hero-content">
            <h1 className="user-hero-title">
              <span className="user-hero-school">
                {institutionName || accountHolderName || "Your School Name"}
              </span>
            </h1>
            <div className="user-hero-actions">
              <button
                type="button"
                className="user-hero-btn user-hero-btn-primary"
                onClick={() => handleSolutionNavigation("schools")}
              >
                Go to My Dashboard &rarr;
              </button>
              <button
                type="button"
                className="user-hero-btn"
                onClick={handleProfileNavigation}
              >
                My Profile
              </button>
            </div>
          </div>
        </div>

        {/* --- CARDS SECTION --- */}
        <section
          className="text-center my-4"
          style={{ fontFamily: "'Segoe UI', sans-serif" }}
        >
          <div className="container-fluid px-0">
            <div className="solutions-columns">
              <div className="solutions-row">
                {/* Column 1: Schools */}
                <div className="solutions-column">
                  <div
                    className="solutions-column-header solutions-header-schools"
                    onClick={() => handleSolutionNavigation("schools")}
                  >
                    <span className="solutions-column-header-icon">
                      <School size={24} />
                    </span>
                    Solutions for Schools
                  </div>
                </div>

                {/* Column 2: Individual Tutors */}
                <div className="solutions-column">
                  <div
                    className="solutions-column-header solutions-header-tutors"
                    onClick={() => handleSolutionNavigation("tutors")}
                  >
                    <span className="solutions-column-header-icon">
                      <GraduationCap size={24} />
                    </span>
                    Solutions for Individual Tutors
                  </div>
                </div>

                {/* Column 3: Coaching / Tuition Centres */}
                <div className="solutions-column">
                  <div
                    className="solutions-column-header solutions-header-coaching"
                    onClick={() => handleSolutionNavigation("coaching")}
                  >
                    <span className="solutions-column-header-icon">
                      <Users size={24} />
                    </span>
                    Solutions for Coaching/Tuition Centres
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* --- FOOTER SECTION --- */}
        <Footer userData={userData} />
      </div>
    </Suspense>
  );
};

export default UserLandingPage;
